import { activityDataByYear } from '@shared/scoring';
import { IActivityData } from '@shared/scoring/types';
import { environment } from 'src/environments/environment';

export class ActivityData {
  static data: IActivityData = activityDataByYear[environment.fraternalYear];
}
